var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blockchain /icon",
    clipPath: "url(#clip0_307_12179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.2245 63.3469H11.1021C5.33124 63.3469 0.653076 58.6688 0.653076 52.8979V26.7755C0.653076 21.0047 5.33124 16.3265 11.1021 16.3265H37.2245C42.9953 16.3265 47.6735 21.0047 47.6735 26.7755V52.8979C47.6735 58.6688 42.9953 63.3469 37.2245 63.3469Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.898 47.6735H26.7755C21.0047 47.6735 16.3265 42.9953 16.3265 37.2245V11.102C16.3265 5.33122 21.0047 0.653053 26.7755 0.653053H52.898C58.6688 0.653053 63.3469 5.33122 63.3469 11.102V37.2245C63.3469 42.9953 58.6688 47.6735 52.898 47.6735Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.0612 55.5103H18.9387C13.1679 55.5103 8.48975 50.8321 8.48975 45.0613V18.9388C8.48975 13.168 13.1679 8.48985 18.9387 8.48985H45.0612C50.832 8.48985 55.5102 13.168 55.5102 18.9388V45.0613C55.5102 50.8321 50.832 55.5103 45.0612 55.5103Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_12179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.26f9cc01ab5b573aa8447589f7fd46cb.svg";
export { ForwardRef as ReactComponent };